/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */
import axios from "axios";
import type { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { useQuery, useMutation } from "@tanstack/react-query";
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey,
} from "@tanstack/react-query";
import type {
  ModelloDispositivoDto,
  ValidationProblemDetails,
  ProblemDetails,
} from ".././models";

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
  T
>() => T extends Y ? 1 : 2
  ? A
  : B;

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<
    { [Q in P]: T[P] },
    { -readonly [Q in P]: T[P] },
    P
  >;
}[keyof T];

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (
  k: infer I
) => void
  ? I
  : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object
        ? NonReadonly<NonNullable<T[P]>>
        : T[P];
    }
  : DistributeReadOnlyOverUnions<T>;

export const getModelliDispositivo = (
  options?: AxiosRequestConfig
): Promise<AxiosResponse<ModelloDispositivoDto[]>> => {
  return axios.get(`/api/modelli-dispositivo`, options);
};

export const getGetModelliDispositivoQueryKey = () =>
  [`/api/modelli-dispositivo`] as const;

export const getGetModelliDispositivoQueryOptions = <
  TData = Awaited<ReturnType<typeof getModelliDispositivo>>,
  TError = AxiosError<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getModelliDispositivo>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getModelliDispositivo>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetModelliDispositivoQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getModelliDispositivo>>
  > = ({ signal }) => getModelliDispositivo({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions };
};

export type GetModelliDispositivoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getModelliDispositivo>>
>;
export type GetModelliDispositivoQueryError = AxiosError<unknown>;

export const useGetModelliDispositivo = <
  TData = Awaited<ReturnType<typeof getModelliDispositivo>>,
  TError = AxiosError<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getModelliDispositivo>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetModelliDispositivoQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createModelloDispositivo = (
  modelloDispositivoDto: NonReadonly<ModelloDispositivoDto>,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<ModelloDispositivoDto>> => {
  return axios.post(`/api/modelli-dispositivo`, modelloDispositivoDto, options);
};

export const getCreateModelloDispositivoMutationOptions = <
  TError = AxiosError<ValidationProblemDetails>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createModelloDispositivo>>,
    TError,
    { data: NonReadonly<ModelloDispositivoDto> },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createModelloDispositivo>>,
  TError,
  { data: NonReadonly<ModelloDispositivoDto> },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createModelloDispositivo>>,
    { data: NonReadonly<ModelloDispositivoDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createModelloDispositivo(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateModelloDispositivoMutationResult = NonNullable<
  Awaited<ReturnType<typeof createModelloDispositivo>>
>;
export type CreateModelloDispositivoMutationBody =
  NonReadonly<ModelloDispositivoDto>;
export type CreateModelloDispositivoMutationError =
  AxiosError<ValidationProblemDetails>;

export const useCreateModelloDispositivo = <
  TError = AxiosError<ValidationProblemDetails>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createModelloDispositivo>>,
    TError,
    { data: NonReadonly<ModelloDispositivoDto> },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getCreateModelloDispositivoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getModelloDispositivo = (
  id: number,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<ModelloDispositivoDto>> => {
  return axios.get(`/api/modelli-dispositivo/${id}`, options);
};

export const getGetModelloDispositivoQueryKey = (id: number) =>
  [`/api/modelli-dispositivo/${id}`] as const;

export const getGetModelloDispositivoQueryOptions = <
  TData = Awaited<ReturnType<typeof getModelloDispositivo>>,
  TError = AxiosError<ProblemDetails>
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getModelloDispositivo>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryOptions<
  Awaited<ReturnType<typeof getModelloDispositivo>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetModelloDispositivoQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getModelloDispositivo>>
  > = ({ signal }) => getModelloDispositivo(id, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetModelloDispositivoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getModelloDispositivo>>
>;
export type GetModelloDispositivoQueryError = AxiosError<ProblemDetails>;

export const useGetModelloDispositivo = <
  TData = Awaited<ReturnType<typeof getModelloDispositivo>>,
  TError = AxiosError<ProblemDetails>
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getModelloDispositivo>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetModelloDispositivoQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateModelloDispositivo = (
  id: number,
  modelloDispositivoDto: NonReadonly<ModelloDispositivoDto>,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.put(
    `/api/modelli-dispositivo/${id}`,
    modelloDispositivoDto,
    options
  );
};

export const getUpdateModelloDispositivoMutationOptions = <
  TError = AxiosError<ValidationProblemDetails | ProblemDetails>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateModelloDispositivo>>,
    TError,
    { id: number; data: NonReadonly<ModelloDispositivoDto> },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateModelloDispositivo>>,
  TError,
  { id: number; data: NonReadonly<ModelloDispositivoDto> },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateModelloDispositivo>>,
    { id: number; data: NonReadonly<ModelloDispositivoDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateModelloDispositivo(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateModelloDispositivoMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateModelloDispositivo>>
>;
export type UpdateModelloDispositivoMutationBody =
  NonReadonly<ModelloDispositivoDto>;
export type UpdateModelloDispositivoMutationError = AxiosError<
  ValidationProblemDetails | ProblemDetails
>;

export const useUpdateModelloDispositivo = <
  TError = AxiosError<ValidationProblemDetails | ProblemDetails>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateModelloDispositivo>>,
    TError,
    { id: number; data: NonReadonly<ModelloDispositivoDto> },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getUpdateModelloDispositivoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const deleteModelloDispositivo = (
  id: number,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.delete(`/api/modelli-dispositivo/${id}`, options);
};

export const getDeleteModelloDispositivoMutationOptions = <
  TError = AxiosError<ProblemDetails>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteModelloDispositivo>>,
    TError,
    { id: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteModelloDispositivo>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteModelloDispositivo>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteModelloDispositivo(id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteModelloDispositivoMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteModelloDispositivo>>
>;

export type DeleteModelloDispositivoMutationError = AxiosError<ProblemDetails>;

export const useDeleteModelloDispositivo = <
  TError = AxiosError<ProblemDetails>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteModelloDispositivo>>,
    TError,
    { id: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getDeleteModelloDispositivoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const downloadModelloImage = (
  id: number,
  fileId: number,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<Blob>> => {
  return axios.get(`/api/modelli-dispositivo/${id}/image/${fileId}`, {
    responseType: "blob",
    ...options,
  });
};

export const getDownloadModelloImageQueryKey = (id: number, fileId: number) =>
  [`/api/modelli-dispositivo/${id}/image/${fileId}`] as const;

export const getDownloadModelloImageQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadModelloImage>>,
  TError = AxiosError<unknown>
>(
  id: number,
  fileId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadModelloImage>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryOptions<
  Awaited<ReturnType<typeof downloadModelloImage>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDownloadModelloImageQueryKey(id, fileId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadModelloImage>>
  > = ({ signal }) =>
    downloadModelloImage(id, fileId, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!(id && fileId), ...queryOptions };
};

export type DownloadModelloImageQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadModelloImage>>
>;
export type DownloadModelloImageQueryError = AxiosError<unknown>;

export const useDownloadModelloImage = <
  TData = Awaited<ReturnType<typeof downloadModelloImage>>,
  TError = AxiosError<unknown>
>(
  id: number,
  fileId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadModelloImage>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getDownloadModelloImageQueryOptions(id, fileId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const __$$useGetModelliDispositivo = () =>
  //@ts-ignore
  useGetModelliDispositivo(...([] as any[]));

export const __$$useCreateModelloDispositivo = () =>
  //@ts-ignore
  useCreateModelloDispositivo(...([] as any[]));

export const __$$useGetModelloDispositivo = () =>
  //@ts-ignore
  useGetModelloDispositivo(...([] as any[]));

export const __$$useUpdateModelloDispositivo = () =>
  //@ts-ignore
  useUpdateModelloDispositivo(...([] as any[]));

export const __$$useDeleteModelloDispositivo = () =>
  //@ts-ignore
  useDeleteModelloDispositivo(...([] as any[]));

export const __$$useDownloadModelloImage = () =>
  //@ts-ignore
  useDownloadModelloImage(...([] as any[]));
